// Traduce errores de sesión del backend en redirecciones y mensajes comprensibles para el login.
export function handleSessionError(reason) {
  const params = new URLSearchParams()

  switch (reason) {
    case 'session_idle_timeout':
    case 'session_absolute_timeout':
    case 'token_expired':
    case 'invalid_token':
      params.set('session_expired', 'true')
      break
    case 'user_inactive':
      params.set('deactivated', 'true')
      break
    case 'account_locked':
      params.set('account_locked', 'true')
      break
    case 'session_replaced':
      params.set('session_replaced', 'true')
      break
    default:
      params.set('session_error', 'true')
      break
  }

  const target = `/?${params.toString()}`
  const current = `${window.location.pathname}${window.location.search}`
  if (current === target) return

  window.location.replace(target)
}

export async function parseErrorReason(response) {
  try {
    const data = await response.json()
    return data.reason || data.error
  } catch {
    return null
  }
}
